import React from 'react';
import { inject, observer } from 'mobx-react';
import Flexbox from 'flexbox-react';
import { Button, InputGroup, Intent } from '@blueprintjs/core';
import classNames from 'classnames';
import _ from 'lodash';

@inject('AccountUsersStore', 'ToastStore')
@observer
export default class AccountUsersNewInvitation extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isSubmitting: false, isBlurred: [] };
  }

  toggleLoading = () => {
    this.setState({
      isSubmitting: !this.state.isSubmitting,
    });
  };

  handleInputChange(e) {
    this.props.AccountUsersStore.updateNewInvitation(
      e.target.value,
      e.target.name
    );
  }

  handleBlurChange(e) {
    if (!_.includes(this.state.isBlurred, e.target.name)) {
      const newBlurState = this.state.isBlurred;
      newBlurState.push(e.target.name);
      this.setState({ isBlurred: newBlurState });
    }
  }

  renderErrors(field) {
    if (
      _.includes(this.state.isBlurred, field) &&
      !this.props.AccountUsersStore.newInvitation[`${field}Valid`]
    ) {
      return (
        <div className="bp3-form-helper-text">
          {
            this.props.AccountUsersStore.newInvitation[
              `${field}Error`
            ]
          }
        </div>
      );
    }
    return undefined;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.AccountUsersStore.newInvitation.emailValid) {
      this.toggleLoading();
      this.props.AccountUsersStore.createInvitation()
        .then(() => {
          this.toggleLoading();
          this.setState({ isBlurred: [] });
        })
        .catch(() => {
          this.toggleLoading();
        });
    } else {
      this.setState({ isBlurred: ['email'] });
    }
  }

  render() {
    return (
      <Flexbox flexDirection="column" flexGrow={1}>
        <form onSubmit={this.handleSubmit.bind(this)}>
          <Flexbox
            flexDirection="row"
            flexGrow={1}
            alignItems="stretch"
          >
            <Flexbox
              flexGrow={1}
              className={
                _.includes(this.state.isBlurred, 'email') &&
                !this.props.AccountUsersStore.newInvitation.emailValid
                  ? classNames('bp3-form-group bp3-intent-danger')
                  : classNames('bp3-form-group')
              }
            >
              <label className="bp3-label" htmlFor="email">
                {I18n.t('js.send_new_invitation_to_email')}
                <span className="bp3-text-muted push-5-l">
                  ({I18n.t('js.required')})
                </span>
              </label>
              <Flexbox
                flexGrow={1}
                className="bp3-form-content"
                flexDirection="column"
              >
                <Flexbox
                  flexGrow={1}
                  flexDirection="row"
                  className={
                    _.includes(this.state.isBlurred, 'email') &&
                    !this.props.AccountUsersStore.newInvitation
                      .emailValid
                      ? classNames(
                          'bp3-input-group bp3-intent-danger'
                        )
                      : classNames('bp3-input-group')
                  }
                >
                  <InputGroup
                    autoComplete="off"
                    className="bp3-fill max-width"
                    type="text"
                    placeholder={I18n.t('js.someone_example_com')}
                    name="email"
                    value={
                      this.props.AccountUsersStore.newInvitation.email
                    }
                    onChange={this.handleInputChange.bind(this)}
                    onBlur={this.handleBlurChange.bind(this)}
                    dir="auto"
                  />
                </Flexbox>
                {this.renderErrors('email')}
              </Flexbox>
            </Flexbox>
          </Flexbox>
          <Flexbox flexDirection="row">
            <Button
              type="submit"
              intent={Intent.PRIMARY}
              className="bp3-icon-envelope bp3-align-right"
              text={I18n.t('js.send_invitation')}
              disabled={
                !this.props.AccountUsersStore.newInvitation.emailValid
              }
              loading={this.state.isSubmitting}
            />
          </Flexbox>
        </form>
      </Flexbox>
    );
  }
}
